import ko from "knockout";
import {CustomError, customFetch as fetch} from "../../../fetch";
import {errorToast, successToast} from "../../../toastr-helper";
import {closePopups} from "../../../init";

class PayrollEmployeesStatusContractTypesPopup {
    static async submit(){
        contractTypesModel.submit()
    }
    static resetValues(){
        contractTypesModel.resetValues()
    }
    static getAvailableContractTypes(id: any, reloadContracts: (selectedTab: number) => void){
        callbackFunction = reloadContracts;
        contractTypesModel.employmentAgreementId(id)
        contractTypesModel.initializeContractTypes();
    }
}

let callbackFunction: any;

export default PayrollEmployeesStatusContractTypesPopup

class ContractTypesPopupModel {
    employmentAgreementId: KnockoutObservable<string>;
    employmentAgreementContractTypes: KnockoutObservableArray<EmploymentAgreementContractType>;
    
    validationErrors: KnockoutObservableArray<CustomError>
    saving: KnockoutObservable<boolean>

    constructor() {
        this.employmentAgreementId = ko.observable<string>();
        this.employmentAgreementContractTypes = ko.observableArray<EmploymentAgreementContractType>([]);
        
        this.validationErrors = ko.observableArray<CustomError>();
        this.saving = ko.observable<boolean>();
    }

    resetValues() {
        this.validationErrors([]);
    }

    async initializeContractTypes() {
        const fd = new FormData();
        fd.append('employmentAgreementId', this.employmentAgreementId());
        
        const response = await fetch(`/Admin/EmployeesRegistrationStatus/GetAvailableContractTypes`, {
            method: 'POST',
            body: fd
        });

        if (response.ok) {
            this.employmentAgreementContractTypes(response.data);
        } else {
            errorToast('Er ging iets mis bij het laden van de afkeur opties');
        }
        
        console.log(this.employmentAgreementContractTypes())
    }

    async submit() {
        let body: any[] = [];

        this.employmentAgreementContractTypes().forEach((r, index) => {
            let contractTypes = {
                companyId: r.companyId,
                employeeId: r.selectedContractType.employeeId,
                contractId: r.selectedContractType.id
            }
            body[index] = contractTypes;
            });
        
        this.saving(true);

        const response = await fetch(`/Admin/EmployeesRegistrationStatus/UpdateContractTypes`, {
            method: 'POST',
            body: JSON.stringify(body)
        });

        if (response.ok) {
            successToast('De wijzigingen zijn opgeslagen');
            closePopups();
            callbackFunction(5);
        } else {
            if (response.errors && response.errors.length > 0) {
                this.validationErrors(response.errors);
            }
        }

        this.saving(false);
    }

    closePopup() {
        closePopups();
    }
}

class EmploymentAgreementContractType {
    contractTypes: KnockoutObservableArray<ContractTypeModel>;
    selectedContractType: KnockoutObservable<SelectedContractTypes>;
    companyId: KnockoutObservable<string>;
    companyName: KnockoutObservable<string>;

    constructor(model: any = {}) {        
        this.contractTypes = ko.observableArray<ContractTypeModel>(model.contractTypes.map((item: any) => new ContractTypeModel(item)));
        this.selectedContractType = ko.observable<SelectedContractTypes>(model.selectedContractTypes);
        this.companyId = ko.observable<string>(model.companyId);
        this.companyName = ko.observable<string>(model.companyName);
    }    
}

class SelectedContractTypes {
    employeeId: KnockoutObservable<string>;
    id: KnockoutObservable<string>;

    constructor(model: any = {}) {
        this.id = ko.observable<string>(model.id || '');
        this.employeeId = ko.observable<string>(model.employeeId || '');
    }
}


class ContractTypeModel {
    id: KnockoutObservable<string>;
    employeeId: KnockoutObservable<string>;
    contractName: KnockoutObservable<string>;

    constructor(model: any = {}) {
        this.id = ko.observable<string>(model.id);
        this.employeeId = ko.observable<string>(model.employeeId);
        this.contractName = ko.observable<string>(model.contractName);
    }
}

const contractTypesModel = new ContractTypesPopupModel();
ko.applyBindings(contractTypesModel, document.getElementById('contractType-file'));
